import { render } from "./VideoIcon.vue?vue&type=template&id=5f2f70ee&scoped=true"
import script from "./VideoIcon.vue?vue&type=script&lang=js"
export * from "./VideoIcon.vue?vue&type=script&lang=js"

import "./VideoIcon.vue?vue&type=style&index=0&id=5f2f70ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2f70ee"]])

export default __exports__